export const rateAction = (data) => ({
  type: "rate",
  data,
});

export const toggleAction = (type) => ({
  type: `${type}/toggle`,
});

export const playStreamAction = (type) => ({
  type: `${type}/playStream`,
});

/**
 * @param {number} value
 */
export const setPlayerVolume = (value) => ({
  type: "set_volume_value",
  payload: value,
});
